export enum NumberFormat {
    None,
    General,
    Currency,
}